import { Airport } from '../../models/response';

export interface AirportsState {
    airports: Airport[];
}

export enum AirportsActionNames {
    LIST = 'LIST',
}
